module.exports = __webpack_public_path__ + "img/Angry.e18b1787.svg";